/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as Authenticate from "./messages";
import * as GenericExceptions from "./../common/exceptions";
import * as PHeader from "./../common/models";
export namespace TAuthenticationService {
    export interface IAuthenticateArgsArgs {
        request: Authenticate.TAuthenticateRequest;
    }
    export class AuthenticateArgs {
        public request: Authenticate.TAuthenticateRequest;
        constructor(args: IAuthenticateArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_1: Authenticate.TAuthenticateRequest = Authenticate.TAuthenticateRequest.read(input);
                            _args.request = value_1;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new AuthenticateArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read AuthenticateArgs from input");
            }
        }
    }
    export interface IRefetchAccessTokenArgsArgs {
        request: Authenticate.TRefetchAccessTokenRequest;
    }
    export class RefetchAccessTokenArgs {
        public request: Authenticate.TRefetchAccessTokenRequest;
        constructor(args: IRefetchAccessTokenArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RefetchAccessTokenArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RefetchAccessTokenArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_2: Authenticate.TRefetchAccessTokenRequest = Authenticate.TRefetchAccessTokenRequest.read(input);
                            _args.request = value_2;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new RefetchAccessTokenArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read RefetchAccessTokenArgs from input");
            }
        }
    }
    export interface IAuthenticateEmailArgsArgs {
        request: Authenticate.TAuthenticateEmailRequest;
    }
    export class AuthenticateEmailArgs {
        public request: Authenticate.TAuthenticateEmailRequest;
        constructor(args: IAuthenticateEmailArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateEmailArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateEmailArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_3: Authenticate.TAuthenticateEmailRequest = Authenticate.TAuthenticateEmailRequest.read(input);
                            _args.request = value_3;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new AuthenticateEmailArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read AuthenticateEmailArgs from input");
            }
        }
    }
    export interface IAuthenticateRaterArgsArgs {
        request: Authenticate.TAuthenticateRaterRequest;
    }
    export class AuthenticateRaterArgs {
        public request: Authenticate.TAuthenticateRaterRequest;
        constructor(args: IAuthenticateRaterArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateRaterArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateRaterArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_4: Authenticate.TAuthenticateRaterRequest = Authenticate.TAuthenticateRaterRequest.read(input);
                            _args.request = value_4;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new AuthenticateRaterArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read AuthenticateRaterArgs from input");
            }
        }
    }
    export interface ISendEmailVerificationArgsArgs {
        request: Authenticate.TSendEmailVerificationRequest;
    }
    export class SendEmailVerificationArgs {
        public request: Authenticate.TSendEmailVerificationRequest;
        constructor(args: ISendEmailVerificationArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SendEmailVerificationArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SendEmailVerificationArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_5: Authenticate.TSendEmailVerificationRequest = Authenticate.TSendEmailVerificationRequest.read(input);
                            _args.request = value_5;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new SendEmailVerificationArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read SendEmailVerificationArgs from input");
            }
        }
    }
    export interface ISendWebAuthRequestArgsArgs {
        request: Authenticate.TWebAuthenticateRequest;
    }
    export class SendWebAuthRequestArgs {
        public request: Authenticate.TWebAuthenticateRequest;
        constructor(args: ISendWebAuthRequestArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SendWebAuthRequestArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SendWebAuthRequestArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_6: Authenticate.TWebAuthenticateRequest = Authenticate.TWebAuthenticateRequest.read(input);
                            _args.request = value_6;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new SendWebAuthRequestArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read SendWebAuthRequestArgs from input");
            }
        }
    }
    export interface IUpdateWebAuthRequestArgsArgs {
        header: PHeader.TAuthHeader;
        request: Authenticate.TWebAuthenticateUpdateRequest;
    }
    export class UpdateWebAuthRequestArgs {
        public header: PHeader.TAuthHeader;
        public request: Authenticate.TWebAuthenticateUpdateRequest;
        constructor(args: IUpdateWebAuthRequestArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateWebAuthRequestArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateWebAuthRequestArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_7: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_7;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_8: Authenticate.TWebAuthenticateUpdateRequest = Authenticate.TWebAuthenticateUpdateRequest.read(input);
                            _args.request = value_8;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateWebAuthRequestArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateWebAuthRequestArgs from input");
            }
        }
    }
    export interface IGetActiveWebAuthRequestArgsArgs {
        header: PHeader.TAuthHeader;
        userId: Authenticate.TUserId;
    }
    export class GetActiveWebAuthRequestArgs {
        public header: PHeader.TAuthHeader;
        public userId: Authenticate.TUserId;
        constructor(args: IGetActiveWebAuthRequestArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.userId != null) {
                this.userId = args.userId;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetActiveWebAuthRequestArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.userId != null) {
                output.writeFieldBegin("userId", thrift.Thrift.Type.STRUCT, 2);
                this.userId.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetActiveWebAuthRequestArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_9: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_9;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_10: Authenticate.TUserId = Authenticate.TUserId.read(input);
                            _args.userId = value_10;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.userId !== undefined) {
                return new GetActiveWebAuthRequestArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GetActiveWebAuthRequestArgs from input");
            }
        }
    }
    export interface IRequestInviteArgsArgs {
        request: Authenticate.TInviteRequest;
    }
    export class RequestInviteArgs {
        public request: Authenticate.TInviteRequest;
        constructor(args: IRequestInviteArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RequestInviteArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RequestInviteArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_11: Authenticate.TInviteRequest = Authenticate.TInviteRequest.read(input);
                            _args.request = value_11;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new RequestInviteArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read RequestInviteArgs from input");
            }
        }
    }
    export interface IAuthenticateHeliosDashboardUserArgsArgs {
        request: Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest;
    }
    export class AuthenticateHeliosDashboardUserArgs {
        public request: Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest;
        constructor(args: IAuthenticateHeliosDashboardUserArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateHeliosDashboardUserArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateHeliosDashboardUserArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_12: Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest = Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest.read(input);
                            _args.request = value_12;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new AuthenticateHeliosDashboardUserArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read AuthenticateHeliosDashboardUserArgs from input");
            }
        }
    }
    export interface IAuthenticateResultArgs {
        success?: Authenticate.TAuthenticateResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        inviteError?: GenericExceptions.TInviteException;
    }
    export class AuthenticateResult {
        public success?: Authenticate.TAuthenticateResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public inviteError?: GenericExceptions.TInviteException;
        constructor(args?: IAuthenticateResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.inviteError != null) {
                this.inviteError = args.inviteError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.inviteError != null) {
                output.writeFieldBegin("inviteError", thrift.Thrift.Type.STRUCT, 3);
                this.inviteError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_13: Authenticate.TAuthenticateResponse = Authenticate.TAuthenticateResponse.read(input);
                            _args.success = value_13;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_14: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_14;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_15: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_15;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 3:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_16: GenericExceptions.TInviteException = GenericExceptions.TInviteException.read(input);
                            _args.inviteError = value_16;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new AuthenticateResult(_args);
        }
    }
    export interface IRefetchAccessTokenResultArgs {
        success?: Authenticate.TRefetchAccessTokenResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class RefetchAccessTokenResult {
        public success?: Authenticate.TRefetchAccessTokenResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IRefetchAccessTokenResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RefetchAccessTokenResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RefetchAccessTokenResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_17: Authenticate.TRefetchAccessTokenResponse = Authenticate.TRefetchAccessTokenResponse.read(input);
                            _args.success = value_17;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_18: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_18;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_19: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_19;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new RefetchAccessTokenResult(_args);
        }
    }
    export interface IAuthenticateEmailResultArgs {
        success?: Authenticate.TAuthenticateEmailResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class AuthenticateEmailResult {
        public success?: Authenticate.TAuthenticateEmailResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IAuthenticateEmailResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateEmailResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateEmailResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_20: Authenticate.TAuthenticateEmailResponse = Authenticate.TAuthenticateEmailResponse.read(input);
                            _args.success = value_20;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_21: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_21;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_22: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_22;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new AuthenticateEmailResult(_args);
        }
    }
    export interface IAuthenticateRaterResultArgs {
        success?: Authenticate.TAuthenticateRaterResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class AuthenticateRaterResult {
        public success?: Authenticate.TAuthenticateRaterResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IAuthenticateRaterResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateRaterResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateRaterResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_23: Authenticate.TAuthenticateRaterResponse = Authenticate.TAuthenticateRaterResponse.read(input);
                            _args.success = value_23;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_24: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_24;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_25: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_25;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new AuthenticateRaterResult(_args);
        }
    }
    export interface ISendEmailVerificationResultArgs {
        success?: Authenticate.TSendEmailVerificationResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class SendEmailVerificationResult {
        public success?: Authenticate.TSendEmailVerificationResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: ISendEmailVerificationResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SendEmailVerificationResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SendEmailVerificationResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_26: Authenticate.TSendEmailVerificationResponse = Authenticate.TSendEmailVerificationResponse.read(input);
                            _args.success = value_26;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_27: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_27;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new SendEmailVerificationResult(_args);
        }
    }
    export interface ISendWebAuthRequestResultArgs {
        success?: Authenticate.TWebAuthenticateStatusResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class SendWebAuthRequestResult {
        public success?: Authenticate.TWebAuthenticateStatusResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: ISendWebAuthRequestResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SendWebAuthRequestResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SendWebAuthRequestResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_28: Authenticate.TWebAuthenticateStatusResponse = Authenticate.TWebAuthenticateStatusResponse.read(input);
                            _args.success = value_28;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_29: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_29;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new SendWebAuthRequestResult(_args);
        }
    }
    export interface IUpdateWebAuthRequestResultArgs {
        success?: Authenticate.TWebAuthenticateUpdateResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateWebAuthRequestResult {
        public success?: Authenticate.TWebAuthenticateUpdateResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateWebAuthRequestResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateWebAuthRequestResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateWebAuthRequestResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_30: Authenticate.TWebAuthenticateUpdateResponse = Authenticate.TWebAuthenticateUpdateResponse.read(input);
                            _args.success = value_30;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_31: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_31;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateWebAuthRequestResult(_args);
        }
    }
    export interface IGetActiveWebAuthRequestResultArgs {
        success?: Authenticate.TActiveWebAuthResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class GetActiveWebAuthRequestResult {
        public success?: Authenticate.TActiveWebAuthResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IGetActiveWebAuthRequestResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetActiveWebAuthRequestResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetActiveWebAuthRequestResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_32: Authenticate.TActiveWebAuthResponse = Authenticate.TActiveWebAuthResponse.read(input);
                            _args.success = value_32;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_33: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_33;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GetActiveWebAuthRequestResult(_args);
        }
    }
    export interface IRequestInviteResultArgs {
        success?: Authenticate.TInviteResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class RequestInviteResult {
        public success?: Authenticate.TInviteResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IRequestInviteResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RequestInviteResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RequestInviteResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_34: Authenticate.TInviteResponse = Authenticate.TInviteResponse.read(input);
                            _args.success = value_34;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_35: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_35;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new RequestInviteResult(_args);
        }
    }
    export interface IAuthenticateHeliosDashboardUserResultArgs {
        success?: Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        authFailedError?: GenericExceptions.TAuthFailed;
    }
    export class AuthenticateHeliosDashboardUserResult {
        public success?: Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public authFailedError?: GenericExceptions.TAuthFailed;
        constructor(args?: IAuthenticateHeliosDashboardUserResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AuthenticateHeliosDashboardUserResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 2);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AuthenticateHeliosDashboardUserResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_36: Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse = Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse.read(input);
                            _args.success = value_36;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_37: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_37;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_38: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_38;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new AuthenticateHeliosDashboardUserResult(_args);
        }
    }
    export class Client {
        public _seqid: number;
        public _reqs: {
            [name: number]: (err: Error | object | undefined, val?: any) => void;
        };
        public output: thrift.TTransport;
        public protocol: new (trans: thrift.TTransport) => thrift.TProtocol;
        constructor(output: thrift.TTransport, protocol: new (trans: thrift.TTransport) => thrift.TProtocol) {
            this._seqid = 0;
            this._reqs = {};
            this.output = output;
            this.protocol = protocol;
        }
        public incrementSeqId(): number {
            return this._seqid += 1;
        }
        public authenticate(request: Authenticate.TAuthenticateRequest): Promise<Authenticate.TAuthenticateResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TAuthenticateResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_authenticate(request, requestId);
            });
        }
        public refetchAccessToken(request: Authenticate.TRefetchAccessTokenRequest): Promise<Authenticate.TRefetchAccessTokenResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TRefetchAccessTokenResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_refetchAccessToken(request, requestId);
            });
        }
        public authenticateEmail(request: Authenticate.TAuthenticateEmailRequest): Promise<Authenticate.TAuthenticateEmailResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TAuthenticateEmailResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_authenticateEmail(request, requestId);
            });
        }
        public authenticateRater(request: Authenticate.TAuthenticateRaterRequest): Promise<Authenticate.TAuthenticateRaterResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TAuthenticateRaterResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_authenticateRater(request, requestId);
            });
        }
        public sendEmailVerification(request: Authenticate.TSendEmailVerificationRequest): Promise<Authenticate.TSendEmailVerificationResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TSendEmailVerificationResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_sendEmailVerification(request, requestId);
            });
        }
        public sendWebAuthRequest(request: Authenticate.TWebAuthenticateRequest): Promise<Authenticate.TWebAuthenticateStatusResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TWebAuthenticateStatusResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_sendWebAuthRequest(request, requestId);
            });
        }
        public updateWebAuthRequest(header: PHeader.TAuthHeader, request: Authenticate.TWebAuthenticateUpdateRequest): Promise<Authenticate.TWebAuthenticateUpdateResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TWebAuthenticateUpdateResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateWebAuthRequest(header, request, requestId);
            });
        }
        public getActiveWebAuthRequest(header: PHeader.TAuthHeader, userId: Authenticate.TUserId): Promise<Authenticate.TActiveWebAuthResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TActiveWebAuthResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_getActiveWebAuthRequest(header, userId, requestId);
            });
        }
        public requestInvite(request: Authenticate.TInviteRequest): Promise<Authenticate.TInviteResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TInviteResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_requestInvite(request, requestId);
            });
        }
        public authenticateHeliosDashboardUser(request: Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest): Promise<Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_authenticateHeliosDashboardUser(request, requestId);
            });
        }
        public send_authenticate(request: Authenticate.TAuthenticateRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("authenticate", thrift.Thrift.MessageType.CALL, requestId);
            const args: AuthenticateArgs = new AuthenticateArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_refetchAccessToken(request: Authenticate.TRefetchAccessTokenRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("refetchAccessToken", thrift.Thrift.MessageType.CALL, requestId);
            const args: RefetchAccessTokenArgs = new RefetchAccessTokenArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_authenticateEmail(request: Authenticate.TAuthenticateEmailRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("authenticateEmail", thrift.Thrift.MessageType.CALL, requestId);
            const args: AuthenticateEmailArgs = new AuthenticateEmailArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_authenticateRater(request: Authenticate.TAuthenticateRaterRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("authenticateRater", thrift.Thrift.MessageType.CALL, requestId);
            const args: AuthenticateRaterArgs = new AuthenticateRaterArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_sendEmailVerification(request: Authenticate.TSendEmailVerificationRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("sendEmailVerification", thrift.Thrift.MessageType.CALL, requestId);
            const args: SendEmailVerificationArgs = new SendEmailVerificationArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_sendWebAuthRequest(request: Authenticate.TWebAuthenticateRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("sendWebAuthRequest", thrift.Thrift.MessageType.CALL, requestId);
            const args: SendWebAuthRequestArgs = new SendWebAuthRequestArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateWebAuthRequest(header: PHeader.TAuthHeader, request: Authenticate.TWebAuthenticateUpdateRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateWebAuthRequest", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateWebAuthRequestArgs = new UpdateWebAuthRequestArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_getActiveWebAuthRequest(header: PHeader.TAuthHeader, userId: Authenticate.TUserId, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("getActiveWebAuthRequest", thrift.Thrift.MessageType.CALL, requestId);
            const args: GetActiveWebAuthRequestArgs = new GetActiveWebAuthRequestArgs({ header, userId });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_requestInvite(request: Authenticate.TInviteRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("requestInvite", thrift.Thrift.MessageType.CALL, requestId);
            const args: RequestInviteArgs = new RequestInviteArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_authenticateHeliosDashboardUser(request: Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("authenticateHeliosDashboardUser", thrift.Thrift.MessageType.CALL, requestId);
            const args: AuthenticateHeliosDashboardUserArgs = new AuthenticateHeliosDashboardUserArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public recv_authenticate(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: AuthenticateResult = AuthenticateResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.inviteError != null) {
                    return callback(result.inviteError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "authenticate failed: unknown result"));
                    }
                }
            }
        }
        public recv_refetchAccessToken(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: RefetchAccessTokenResult = RefetchAccessTokenResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "refetchAccessToken failed: unknown result"));
                    }
                }
            }
        }
        public recv_authenticateEmail(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: AuthenticateEmailResult = AuthenticateEmailResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "authenticateEmail failed: unknown result"));
                    }
                }
            }
        }
        public recv_authenticateRater(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: AuthenticateRaterResult = AuthenticateRaterResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "authenticateRater failed: unknown result"));
                    }
                }
            }
        }
        public recv_sendEmailVerification(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: SendEmailVerificationResult = SendEmailVerificationResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "sendEmailVerification failed: unknown result"));
                    }
                }
            }
        }
        public recv_sendWebAuthRequest(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: SendWebAuthRequestResult = SendWebAuthRequestResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "sendWebAuthRequest failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateWebAuthRequest(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateWebAuthRequestResult = UpdateWebAuthRequestResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateWebAuthRequest failed: unknown result"));
                    }
                }
            }
        }
        public recv_getActiveWebAuthRequest(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GetActiveWebAuthRequestResult = GetActiveWebAuthRequestResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "getActiveWebAuthRequest failed: unknown result"));
                    }
                }
            }
        }
        public recv_requestInvite(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: RequestInviteResult = RequestInviteResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "requestInvite failed: unknown result"));
                    }
                }
            }
        }
        public recv_authenticateHeliosDashboardUser(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: AuthenticateHeliosDashboardUserResult = AuthenticateHeliosDashboardUserResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "authenticateHeliosDashboardUser failed: unknown result"));
                    }
                }
            }
        }
    }
    export interface IHandler {
        authenticate(request: Authenticate.TAuthenticateRequest): Authenticate.TAuthenticateResponse | Promise<Authenticate.TAuthenticateResponse>;
        refetchAccessToken(request: Authenticate.TRefetchAccessTokenRequest): Authenticate.TRefetchAccessTokenResponse | Promise<Authenticate.TRefetchAccessTokenResponse>;
        authenticateEmail(request: Authenticate.TAuthenticateEmailRequest): Authenticate.TAuthenticateEmailResponse | Promise<Authenticate.TAuthenticateEmailResponse>;
        authenticateRater(request: Authenticate.TAuthenticateRaterRequest): Authenticate.TAuthenticateRaterResponse | Promise<Authenticate.TAuthenticateRaterResponse>;
        sendEmailVerification(request: Authenticate.TSendEmailVerificationRequest): Authenticate.TSendEmailVerificationResponse | Promise<Authenticate.TSendEmailVerificationResponse>;
        sendWebAuthRequest(request: Authenticate.TWebAuthenticateRequest): Authenticate.TWebAuthenticateStatusResponse | Promise<Authenticate.TWebAuthenticateStatusResponse>;
        updateWebAuthRequest(header: PHeader.TAuthHeader, request: Authenticate.TWebAuthenticateUpdateRequest): Authenticate.TWebAuthenticateUpdateResponse | Promise<Authenticate.TWebAuthenticateUpdateResponse>;
        getActiveWebAuthRequest(header: PHeader.TAuthHeader, userId: Authenticate.TUserId): Authenticate.TActiveWebAuthResponse | Promise<Authenticate.TActiveWebAuthResponse>;
        requestInvite(request: Authenticate.TInviteRequest): Authenticate.TInviteResponse | Promise<Authenticate.TInviteResponse>;
        authenticateHeliosDashboardUser(request: Authenticate.TAuthenticateHeliosOrderDashboardLoginRequest): Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse | Promise<Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse>;
    }
    export class Processor {
        public _handler: IHandler;
        constructor(handler: IHandler) {
            this._handler = handler;
        }
        public process(input: thrift.TProtocol, output: thrift.TProtocol): void {
            const metadata: thrift.TMessage = input.readMessageBegin();
            const fname: string = metadata.fname;
            const requestId: number = metadata.rseqid;
            const methodName: string = "process_" + fname;
            switch (methodName) {
                case "process_authenticate": {
                    this.process_authenticate(requestId, input, output);
                    return;
                }
                case "process_refetchAccessToken": {
                    this.process_refetchAccessToken(requestId, input, output);
                    return;
                }
                case "process_authenticateEmail": {
                    this.process_authenticateEmail(requestId, input, output);
                    return;
                }
                case "process_authenticateRater": {
                    this.process_authenticateRater(requestId, input, output);
                    return;
                }
                case "process_sendEmailVerification": {
                    this.process_sendEmailVerification(requestId, input, output);
                    return;
                }
                case "process_sendWebAuthRequest": {
                    this.process_sendWebAuthRequest(requestId, input, output);
                    return;
                }
                case "process_updateWebAuthRequest": {
                    this.process_updateWebAuthRequest(requestId, input, output);
                    return;
                }
                case "process_getActiveWebAuthRequest": {
                    this.process_getActiveWebAuthRequest(requestId, input, output);
                    return;
                }
                case "process_requestInvite": {
                    this.process_requestInvite(requestId, input, output);
                    return;
                }
                case "process_authenticateHeliosDashboardUser": {
                    this.process_authenticateHeliosDashboardUser(requestId, input, output);
                    return;
                }
                default: {
                    input.skip(thrift.Thrift.Type.STRUCT);
                    input.readMessageEnd();
                    const errMessage = "Unknown function " + fname;
                    const err = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN_METHOD, errMessage);
                    output.writeMessageBegin(fname, thrift.Thrift.MessageType.EXCEPTION, requestId);
                    err.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            }
        }
        public process_authenticate(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TAuthenticateResponse>((resolve, reject): void => {
                try {
                    const args: AuthenticateArgs = AuthenticateArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.authenticate(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TAuthenticateResponse): void => {
                const result: AuthenticateResult = new AuthenticateResult({ success: data });
                output.writeMessageBegin("authenticate", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: AuthenticateResult = new AuthenticateResult({ authFailedError: err });
                    output.writeMessageBegin("authenticate", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: AuthenticateResult = new AuthenticateResult({ invalidRequestError: err });
                    output.writeMessageBegin("authenticate", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInviteException) {
                    const result: AuthenticateResult = new AuthenticateResult({ inviteError: err });
                    output.writeMessageBegin("authenticate", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("authenticate", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_refetchAccessToken(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TRefetchAccessTokenResponse>((resolve, reject): void => {
                try {
                    const args: RefetchAccessTokenArgs = RefetchAccessTokenArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.refetchAccessToken(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TRefetchAccessTokenResponse): void => {
                const result: RefetchAccessTokenResult = new RefetchAccessTokenResult({ success: data });
                output.writeMessageBegin("refetchAccessToken", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: RefetchAccessTokenResult = new RefetchAccessTokenResult({ authFailedError: err });
                    output.writeMessageBegin("refetchAccessToken", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: RefetchAccessTokenResult = new RefetchAccessTokenResult({ invalidRequestError: err });
                    output.writeMessageBegin("refetchAccessToken", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("refetchAccessToken", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_authenticateEmail(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TAuthenticateEmailResponse>((resolve, reject): void => {
                try {
                    const args: AuthenticateEmailArgs = AuthenticateEmailArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.authenticateEmail(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TAuthenticateEmailResponse): void => {
                const result: AuthenticateEmailResult = new AuthenticateEmailResult({ success: data });
                output.writeMessageBegin("authenticateEmail", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: AuthenticateEmailResult = new AuthenticateEmailResult({ authFailedError: err });
                    output.writeMessageBegin("authenticateEmail", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: AuthenticateEmailResult = new AuthenticateEmailResult({ invalidRequestError: err });
                    output.writeMessageBegin("authenticateEmail", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("authenticateEmail", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_authenticateRater(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TAuthenticateRaterResponse>((resolve, reject): void => {
                try {
                    const args: AuthenticateRaterArgs = AuthenticateRaterArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.authenticateRater(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TAuthenticateRaterResponse): void => {
                const result: AuthenticateRaterResult = new AuthenticateRaterResult({ success: data });
                output.writeMessageBegin("authenticateRater", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: AuthenticateRaterResult = new AuthenticateRaterResult({ authFailedError: err });
                    output.writeMessageBegin("authenticateRater", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: AuthenticateRaterResult = new AuthenticateRaterResult({ invalidRequestError: err });
                    output.writeMessageBegin("authenticateRater", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("authenticateRater", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_sendEmailVerification(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TSendEmailVerificationResponse>((resolve, reject): void => {
                try {
                    const args: SendEmailVerificationArgs = SendEmailVerificationArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.sendEmailVerification(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TSendEmailVerificationResponse): void => {
                const result: SendEmailVerificationResult = new SendEmailVerificationResult({ success: data });
                output.writeMessageBegin("sendEmailVerification", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: SendEmailVerificationResult = new SendEmailVerificationResult({ invalidRequestError: err });
                    output.writeMessageBegin("sendEmailVerification", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("sendEmailVerification", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_sendWebAuthRequest(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TWebAuthenticateStatusResponse>((resolve, reject): void => {
                try {
                    const args: SendWebAuthRequestArgs = SendWebAuthRequestArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.sendWebAuthRequest(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TWebAuthenticateStatusResponse): void => {
                const result: SendWebAuthRequestResult = new SendWebAuthRequestResult({ success: data });
                output.writeMessageBegin("sendWebAuthRequest", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: SendWebAuthRequestResult = new SendWebAuthRequestResult({ invalidRequestError: err });
                    output.writeMessageBegin("sendWebAuthRequest", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("sendWebAuthRequest", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateWebAuthRequest(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TWebAuthenticateUpdateResponse>((resolve, reject): void => {
                try {
                    const args: UpdateWebAuthRequestArgs = UpdateWebAuthRequestArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateWebAuthRequest(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TWebAuthenticateUpdateResponse): void => {
                const result: UpdateWebAuthRequestResult = new UpdateWebAuthRequestResult({ success: data });
                output.writeMessageBegin("updateWebAuthRequest", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateWebAuthRequestResult = new UpdateWebAuthRequestResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateWebAuthRequest", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateWebAuthRequest", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_getActiveWebAuthRequest(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TActiveWebAuthResponse>((resolve, reject): void => {
                try {
                    const args: GetActiveWebAuthRequestArgs = GetActiveWebAuthRequestArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.getActiveWebAuthRequest(args.header, args.userId));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TActiveWebAuthResponse): void => {
                const result: GetActiveWebAuthRequestResult = new GetActiveWebAuthRequestResult({ success: data });
                output.writeMessageBegin("getActiveWebAuthRequest", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GetActiveWebAuthRequestResult = new GetActiveWebAuthRequestResult({ invalidRequestError: err });
                    output.writeMessageBegin("getActiveWebAuthRequest", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("getActiveWebAuthRequest", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_requestInvite(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TInviteResponse>((resolve, reject): void => {
                try {
                    const args: RequestInviteArgs = RequestInviteArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.requestInvite(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TInviteResponse): void => {
                const result: RequestInviteResult = new RequestInviteResult({ success: data });
                output.writeMessageBegin("requestInvite", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: RequestInviteResult = new RequestInviteResult({ invalidRequestError: err });
                    output.writeMessageBegin("requestInvite", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("requestInvite", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_authenticateHeliosDashboardUser(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse>((resolve, reject): void => {
                try {
                    const args: AuthenticateHeliosDashboardUserArgs = AuthenticateHeliosDashboardUserArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.authenticateHeliosDashboardUser(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: Authenticate.TAuthenticateHeliosOrderDashboardLoginResponse): void => {
                const result: AuthenticateHeliosDashboardUserResult = new AuthenticateHeliosDashboardUserResult({ success: data });
                output.writeMessageBegin("authenticateHeliosDashboardUser", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: AuthenticateHeliosDashboardUserResult = new AuthenticateHeliosDashboardUserResult({ invalidRequestError: err });
                    output.writeMessageBegin("authenticateHeliosDashboardUser", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: AuthenticateHeliosDashboardUserResult = new AuthenticateHeliosDashboardUserResult({ authFailedError: err });
                    output.writeMessageBegin("authenticateHeliosDashboardUser", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("authenticateHeliosDashboardUser", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
    }
}
